import React from 'react';
import { Box, Flex, VStack, Heading, Divider, useColorModeValue } from '@chakra-ui/react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import HeaderMenus from '../HeaderMenus';

const SidebarLink = ({ to, children }) => {
  const location = useLocation();
  const isActive = location.pathname === to;
  const activeBg = useColorModeValue('blue.50', 'blue.900');
  const activeColor = useColorModeValue('blue.700', 'blue.200');
  const hoverBg = useColorModeValue('gray.100', 'gray.700');

  return (
    <Box
      as={NavLink}
      to={to}
      w="100%"
      p={3}
      borderRadius="md"
      bg={isActive ? activeBg : 'transparent'}
      color={isActive ? activeColor : 'inherit'}
      fontWeight={isActive ? 'bold' : 'normal'}
      _hover={{
        bg: isActive ? activeBg : hoverBg,
        textDecoration: 'none',
      }}
      transition="all 0.2s"
    >
      {children}
    </Box>
  );
};

const GuidelinesLayout = () => {
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <Box minH="100vh" bg={useColorModeValue('gray.50', 'gray.900')}>
      <HeaderMenus />
      <Flex maxW="1400px" mx="auto" pt={8} px={4} gap={8} align="flex-start">
        {/* Sidebar */}
        <Box
          w="300px"
          flexShrink={0}
          bg={useColorModeValue('white', 'gray.800')}
          p={5}
          borderRadius="lg"
          boxShadow="sm"
          border="1px solid"
          borderColor={borderColor}
          position="sticky"
          top="100px"
        >
          <Heading size="md" mb={4} color="brand.700">
            MPH Coding Guidelines
          </Heading>
          <Divider mb={4} />
          <VStack align="stretch" spacing={2}>
            <SidebarLink to="/mph-guidelines/icd10-sa-hp">
              ICD-10 Surgical Assist H&P
            </SidebarLink>
            <SidebarLink to="/mph-guidelines/icd10-modifiers">
              ICD-10 Optional Modifiers
            </SidebarLink>
          </VStack>
        </Box>

        {/* Main Content Area */}
        <Box
          flex={1}
          bg={useColorModeValue('white', 'gray.800')}
          p={8}
          borderRadius="lg"
          boxShadow="sm"
          border="1px solid"
          borderColor={borderColor}
          minH="calc(100vh - 150px)"
        >
          <Outlet />
        </Box>
      </Flex>
    </Box>
  );
};

export default GuidelinesLayout;